<template>
    <div>
        <base-crud
                crudName="Administradores"
                newText="Novo Administrador"
                :table="usersTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function(){
            return {
                usersTable: 'usersTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'email', 'role', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'name', 'email', 'role'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    templates: {
                        role: function (h, row, index) {
                            return row.paper.name;
                        }
                    },
                    headings: {
                        'name': 'Nome',
                        'email': 'E-mail',
                        'role': 'Papel',
                        'actions': 'Ações'
                    }
                },
                endPoint: 'admin/'
            }
        },
        components: {
            BaseCrud
        }

    }
</script>

<style>

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Crud.vue